const errorLang = {
  email: {
    en: 'That doesn’t appear to be a valid email address. Please check your entry.',
    fr: 'Cette adresse courriel semble incorrecte. Veuillez vérifier votre saisie.'
  },
  name: {
    en: 'There are some unusual characters in your entry. This field accepts only letters, hyphens(-) or apostrophes(’).',
    fr: "Votre saisie comprend des caractères inhabituels. Ce champ n'accepte que des lettres, des tirets (-) ou des apostrophes (’)"
  },
  isAlphaNumeric: {
    en: 'There are some unusual characters in your entry. This field accepts only letters and numbers.',
    fr: 'There are some unusual characters in your entry. This field accepts only letters and numbers. (fr)',
  },
  postalcode: {
    en: 'This doesn’t seem to be a valid Canadian postal code. Please check your entry.',
    fr: 'Ce code postal ne semble pas être un code postal canadien valide. Veuillez vérifier votre saisie.'
  },
  phone: {
    en: "Please enter in a valid phone number.",
    fr: "Please enter in a valid phone number."
  },
  required: {
    en: 'This is a required field.',
    fr: 'Ce champ est obligatoire.'
  },
  subject: {
    en: 'In order to help us deal with your query quickly, we need a subject for your email.',
    fr: 'Afin de nous aider à traiter rapidement votre demande, nous avons besoin d’un sujet pour votre courriel.'
  },
  vin: {
    en: 'The Vehicle Identification Number (VIN) you have entered is not valid.',
    fr: 'Le numéro d’identification de véhicule que vous avez entré n’est pas valide.'
  },
  odometer: {
    en: 'The odometer value you have entered must be a number.',
    fr: 'La valeur saisie pour l\'odomètre doit être un nombre.'
  },
  nameMaxMin: {
    en: 'Please enter a name between 2 and 50 characters.',
    fr: 'Veuillez entrer un nom comprenant entre 2 et 50 caractères.'
  },
  general: {
    en: 'An unknown server error occured. Try again later.',
    fr: 'Une erreur de serveur s’est produite. Veuillez réessayer plus tard.'
  },
  optin: {
    en: 'This is a required field.',
    fr: 'Ce champ est obligatoire.'
  },
  positive: {
    en: 'This must be a positive number.',
    fr: 'This must be a positive number. (FR)'
  },
}

export default errorLang;